import React from 'react';
import './WebGest.scss';
//#region COMPONENTS
import Auth from './Auth/Auth';
import Site from './Site/Site';
import SplashScreen from './SplashScreen/SplashScreen';
//#endregion
//MODELS
import { GestFeedback, ISharedConfig } from '@shared/library';
//CONTEXTS
export const CntxConfig = React.createContext<ISharedConfig | undefined>(undefined);

const WebGest = () => {
    const [conf, setConf] = React.useState<ISharedConfig | undefined>({ session: { support: false } });

    const cntxConfig = { ...conf, set: setConf };

    return (
        <CntxConfig.Provider value={cntxConfig} >
            {conf?.session && !conf.session.userData ? <SplashScreen />//check if logged in
                : conf?.session && conf.session.userData ? <Site />//logged in
                    : <Auth />//logged out
            }

            {/* snackbar and dialog of the whole app: the login uses them too */}
            <GestFeedback {...cntxConfig} />
        </CntxConfig.Provider>
    );
};
export default WebGest;